import { MouseEventHandler } from "react";

import { getDateWithDayOfWeekString } from "../../../libs/dateFormat";

import { useUserContext } from "../../../contexts/userContext";

import { SpaceReservationDetail } from "../../../services/spaceReservationServices";

import CommonPopup from "../../Popup";
import BottomButtonGroup from "../../Button/Bottom";

type Props = {
  isOpen: boolean;
  title: string;
  detail: SpaceReservationDetail | Partial<SpaceReservationDetail>;
  onClickDetail: MouseEventHandler<HTMLButtonElement>;
  onClose?: () => void;
};
export default function ReservationDetailPopup({
  isOpen,
  title,
  detail,
  onClickDetail,
  onClose,
}: Props) {
  const [user] = useUserContext();

  return (
    <CommonPopup
      title="회의실 상세 보기"
      isOpen={isOpen}
      padding={5}
      onClose={onClose}
    >
      <div className="flex flex-col gap-5 h-[35vh]">
        {detail?.spaceInfo?.fileInfo?.items[1]?.url && (
          <div className="">
            <img
              src={detail?.spaceInfo?.fileInfo?.items[1]?.url}
              alt="회의실 이미지"
              className="h-[36px] w-full object-cover"
            />
          </div>
        )}
        <div className="flex flex-col gap-2">
          <div className="flex flex-row text-xl font-medium leading-[24px]">
            {`[${title}] ${detail.spaceInfo?.buildingName || ""} ${
              detail.spaceInfo?.buildingFloorName || ""
            } ${detail.spaceInfo?.reservationSpaceName || ""}`}
          </div>
          <div className="flex flex-row">
            <div className="text-xs text-brand-neutral-40">
              {`${getDateWithDayOfWeekString(
                new Date(detail.reservationDate ?? new Date())
              )} / ${detail.reservationTimeStart} ~ ${
                detail.reservationTimeEnd
              }`}
            </div>
          </div>
          <div className="flex flex-row">
            <div className="text-xs text-brand-neutral-40">
              {user?.companyName}
            </div>
          </div>
        </div>
        <BottomButtonGroup
          title="자세히 보기"
          variant="white"
          className="border border-gray-200"
          onClick={onClickDetail}
        />
      </div>
    </CommonPopup>
  );
}
